export default __webpack_public_path__ + "static/media/banarasi1.ed1743a0.jpg";